module.exports = __webpack_public_path__ + "static/partner-img-2-1624e1b8ee938f58a4432751fcfdef29.png";